import { api } from "api";

export const getEmployees = (onBegin, onSuccess, onError) => {
  return async (dispatch) => {
    onBegin();
    await api
      .get("/api/employee-management/employees")
      .then((res) => {
        dispatch({
          type: "GET_EMPLOYEES_SUCCESS",
          payload: res.data,
        });

        onSuccess();
      })
      .catch((e) => {
        dispatch({
          type: "GET_EMPLOYEES_ERROR",
          payload: e,
        });
        onError(e);
      });
  };
};

export const getEmployee = (employeeId, onBegin, onSuccess, onError) => {
  return async (dispatch) => {
    onBegin();
    await api
      .get("/api/employee-management/employee/" + employeeId)
      .then((res) => {
        onSuccess(res);
      })
      .catch((e) => {
        onError(e);
      });
  };
};

export const getPositions = (companyId = null, onBegin, onSuccess, onError) => {
  return async (dispatch) => {
    onBegin();
    let endpoint = "/api/employee-management/positions";
    if (companyId) endpoint += `/${companyId}`;
    await api
      .get(endpoint)
      .then((res) => {
        onSuccess(res);
      })
      .catch((e) => {
        onError(e);
      });
  };
};

export const getExportCompanies = (onBegin, onSuccess, onError) => {
  return async (dispatch) => {
    onBegin();
    await api
      .get("/api/employee-management/companies")
      .then((res) => {
        onSuccess(res);
      })
      .catch((e) => {
        onError(e);
      });
  };
};

export const createEmployee = (formData, onBegin, onSuccess, onError) => {
  return async (dispatch) => {
    onBegin();
    await api
      .post("/api/employee-management/create", formData)
      .then((res) => {
        onSuccess(res);
      })
      .catch((e) => {
        onError(e);
      });
  };
};

export const updateEmployee = (
  employeeId,
  formData,
  onBegin,
  onSuccess,
  onError
) => {
  return async (dispatch) => {
    onBegin();
    await api
      .post(`/api/employee-management/update/${employeeId}`, formData)
      .then((res) => {
        onSuccess(res);
      })
      .catch((e) => {
        onError(e);
      });
  };
};

export const positionChange = (
  employeeId,
  formData,
  onBegin,
  onSuccess,
  onError
) => {
  return async (dispatch) => {
    onBegin();
    await api
      .post(`/api/employee-management/position-change/${employeeId}`, formData)
      .then((res) => {
        onSuccess(res);
      })
      .catch((e) => {
        onError(e);
      });
  };
};

export const companyTransfer = (
  employeeId,
  formData,
  onBegin,
  onSuccess,
  onError
) => {
  return async (dispatch) => {
    onBegin();
    await api
      .post(`/api/employee-management/company-transfer/${employeeId}`, formData)
      .then((res) => {
        onSuccess(res);
      })
      .catch((e) => {
        onError(e);
      });
  };
};

export const jobTermination = (
  employeeId,
  formData,
  onBegin,
  onSuccess,
  onError
) => {
  return async (dispatch) => {
    onBegin();
    await api
      .post(`/api/employee-management/job-termination/${employeeId}`, formData)
      .then((res) => {
        onSuccess(res);
      })
      .catch((e) => {
        onError(e);
      });
  };
};
